export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    navbarBg: p => p.tertiaryDark,
    background: p => p.tertiaryDark,
    newsBackground: p => p.primaryLight,
    socialColor: p => p.accentWhite,
    slideCounter: p => p.accentWhite
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryLight,
    background: p => p.tertiaryLight,
    newsBackground: p => p.primaryDark,
    socialColor: p => p.tertiaryDark,
    slideCounter: p => p.tertiaryDark
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight,
    newsBackground: p => p.primaryDark,
    socialColor: p => p.tertiaryDark,
    slideCounter: p => p.tertiaryDark
  }
}
